// 模块
export default {
	home: {
		name: "首页"
	},
	page_out_trade_no: "商户单号",
	submit_modeling_model_file_not_ready: "模型文件暂未准备完成，请稍后重试或联系客服处理"
};
